import React from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Buttons from '@material-ui/core/Button';
import { Image, Button } from 'semantic-ui-react';

export default class ViewAllGroupParts extends React.Component {

    state = {

    }

    addItem(item) {
        let customerDualScreenorderList = localStorage.getItem("customerDualScreenorderList");
        if (!customerDualScreenorderList) {
            customerDualScreenorderList = "[]";
        }
        try {
            customerDualScreenorderList = JSON.parse(customerDualScreenorderList);
            if (!customerDualScreenorderList) {
                customerDualScreenorderList = [];
            }
            let refId = 0;
            let value = 0;
            customerDualScreenorderList.map((v) => {
                if (v.partno == item.partno) {
                    value = 1;
                    v.qty = v.qty + 1;
                    v.quantity = v.quantity + 1;
                }
                else { 
                    refId = v.refId;
                }
            })
            refId = refId + 1;
            if (value == 0) {
                customerDualScreenorderList.push({ 
                    'partno': item.partno, 'discountrs': 0,
                    'spare_name': item.title, 'partname': item.title, 'discountper': 0, 'point': 0, 'ava_stocks': 0, 
                    'qty': 1, 'refId': refId, 'brand': 1, 'remarks': 'remarks',
                    'tax': item.tax, 'discount': 0, 'quantity': 1, checked: false,
                    'billtype': 'Invoice', 'mrp': item.mrp, 'uprice': item.mrp, 
                })
            }
            customerDualScreenorderList = JSON.stringify(customerDualScreenorderList);
            localStorage.setItem("customerDualScreenorderList", customerDualScreenorderList);
            this.props.refreshData();
            this.setState({ customerDualScreenorderList })
        } catch (error) {
        }
    }

    getSpareDetails(partno, item) {
        this.props.detailsSparesPage(partno, item);
    }

  render() {
    return (
        <Grid container spacing={0}>
        {
            this.props.originaldata.map((c) => {
                if (this.props.status == 1) {
                    if (c.sets == this.props.name) {
                        return (
                            <Grid item xs={12}>
                                <Paper>
                                    <div style={{display: 'flex', width: '100%'}}>
                                        <div style={{width: '20%', cursor: 'pointer'}} onClick={this.getSpareDetails.bind(this, c.partno, c)}>
                                            <Image  src={"https://s3.ap-south-1.amazonaws.com/vaigaiclaas.com/feature/"+c.partno+".jpg"} style={{width: '100px', height: '100px', borderRadius: '5px', margin: '3px'}} />
                                        </div>
                                        <div style={{padding: '5px', width: '65%', cursor: 'pointer'}} onClick={this.getSpareDetails.bind(this, c.partno, c)}>
                                            <b style={{fontSize: '16px'}}>{c.title+'('+c.partno+')'}</b>
                                            <div>{c.tamil_name}</div>
                                            <div>{c.local_name}</div>
                                            <div>{c.description}</div>
                                        </div>
                                        <div style={{width: '15%'}}>
                                            <Button style={{backgroundColor: '#abb119', color: 'white', marginTop: '4px'}} 
                                                onClick={this.addItem.bind(this, c)}>ADD</Button>
                                        </div>
                                    </div>
                                </Paper>
                            </Grid>
                        )
                    }
                }
                else {
                    if (c.categories == this.props.name) {
                        return (
                            <Grid item xs={12}>
                                <Paper>
                                    <div style={{display: 'flex', width: '100%'}}>
                                        <div style={{width: '20%', cursor: 'pointer'}} onClick={this.getSpareDetails.bind(this, c.partno, c)}>
                                            <Image  src={"https://s3.ap-south-1.amazonaws.com/vaigaiclaas.com/feature/"+c.partno+".jpg"} style={{width: '100px', height: '100px', borderRadius: '5px', margin: '3px'}} />
                                        </div>
                                        <div style={{padding: '5px', width: '65%', cursor: 'pointer'}} onClick={this.getSpareDetails.bind(this, c.partno, c)}>
                                            <b style={{fontSize: '16px'}}>{c.title+'('+c.partno+')'}</b>
                                            <div>{c.tamil_name}</div>
                                            <div>{c.local_name}</div>
                                            <div>{c.description}</div>
                                        </div>
                                        <div style={{width: '15%'}}>
                                            <Button style={{backgroundColor: '#abb119', color: 'white', marginTop: '4px'}} 
                                                onClick={this.addItem.bind(this, c)}>ADD</Button>
                                        </div>
                                    </div>
                                </Paper>
                            </Grid>
                        )
                    }
                }
            })
        }
      </Grid>
    );
  }

}